import { useMemo, useState } from 'react';

interface UseOnboardingYearOptionsResult {
  yearOptions: number[];
  allYearOptions: number[];
  visibleYearCount: number;
  canShowMoreYears: boolean;
  handleShowMoreYears: () => void;
  yearTransactionEstimates: Record<number, string>;
  setYearTransactionEstimates: React.Dispatch<React.SetStateAction<Record<number, string>>>;
}

export const useOnboardingYearOptions = (): UseOnboardingYearOptionsResult => {
  const currentYear = new Date().getFullYear();
  const [visibleYearCount, setVisibleYearCount] = useState(4); // Start with 4 years (current + 3 past)
  const [yearTransactionEstimates, setYearTransactionEstimates] = useState<Record<number, string>>({});

  const allYearOptions = useMemo(() => {
    const years = [];
    // Generate more years than we'll initially show (current + 11 past = 12 total)
    for (let i = 0; i < 12; i++) {
      years.push(currentYear - i);
    }
    return years;
  }, [currentYear]);

  const yearOptions = useMemo(() => {
    return allYearOptions.slice(0, visibleYearCount);
  }, [allYearOptions, visibleYearCount]);

  const canShowMoreYears = visibleYearCount < allYearOptions.length;

  const handleShowMoreYears = () => {
    setVisibleYearCount((prev) => Math.min(prev + 4, allYearOptions.length));
  };

  return {
    yearOptions,
    allYearOptions,
    visibleYearCount,
    canShowMoreYears,
    handleShowMoreYears,
    yearTransactionEstimates,
    setYearTransactionEstimates,
  };
};
